var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{ref:"tooltips",staticClass:"ur-data-grid__edit__element__message--error",style:(_vm.tooltipStyle)},[_vm._v("\n    "+_vm._s(_vm.data.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }